import React from 'react';

function PhoneIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20">
      <g clipPath="url(#clip0_4075_30897)">
        <path
          fill="#4B4B4B"
          d="M15.177 10.707l5.221 5.22-2.642 2.643A4.91 4.91 0 0114.25 20C8.21 20 .5 12.29.5 6.25a4.917 4.917 0 011.43-3.507L4.572.102l5.221 5.22L6.356 8.76a10.113 10.113 0 005.377 5.39l3.444-3.443zm3.656-2.374H20.5A8.343 8.343 0 0012.167 0v1.667a6.674 6.674 0 016.666 6.666zm-3.333 0h1.667a5.005 5.005 0 00-5-5V5A3.333 3.333 0 0115.5 8.333z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4075_30897">
          <path fill="#fff" d="M0 0H20V20H0z" transform="translate(.5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default PhoneIcon;
